const development = require('./development');

const { env, deploy, logger, elastic } = development;

module.exports = {
  ...development,
  mode: 'production',
  sourceMap: 'source-map',
  urlRoot: `https://${env}.ls-www.localsearch.cloud`,
  logger: {
    ...logger,
    console: {
      level: 'debug',
    },
  },
  serviceApiRoot: 'https://staging.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://staging.services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://dkw8fcvpqki80.cloudfront.net',
  filemakerApiRoot:
    'https://fmwdz3tq57.execute-api.ap-southeast-2.amazonaws.com/staging',
  elastic: {
    ...elastic,
    node:
      'https://vpc-ls-services-staging-lr6p57o4tb22vihz46cv4x645i.ap-southeast-2.es.amazonaws.com',
  },
  auth: {
    ...development.auth,
    redirectUri: `https://${env}.ls-www.localsearch.cloud/login-loader`,
    returnTo: `https://${env}.ls-www.localsearch.cloud`,
  },
  deploy: {
    ...deploy,
    domain: 'ls-www.localsearch.cloud',
    subDomain: `${env}.ls-www.localsearch.cloud`,
    aliases: `${env}.ls-www.localsearch.cloud`,
    webAcl:
      'arn:aws:wafv2:us-east-1:789417954668:global/webacl/ls-web-react-development/dd0deeb0-39f8-46ea-9a5b-47f12c4ee637',
    logBucket: 'ls-web-react-logs-dev',
  },
};
